<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="card mb-4">
                <div class="card-header pb-0">
                    <h6>
                        تایید و رد اطلاعات بارگذاری شده
                    </h6>
                </div>
                <div class="card-body px-0 pt-0 pb-2">
                    <div class="table-responsive p-0">
                        <table class="table align-items-center justify-content-center mb-0 ">
                            <thead>
                                <tr>
                                    <th class="text-center ">عنوان اطلاعات</th>
                                    <th class="text-center ">زمان ثبت</th>
                                    <th class="text-center ">مربوط به</th>
                                    <th class="text-center ">ثبت کننده</th>
                                    <th class="text-center ">وضعیت جاری</th>
                                    <th class="text-center ">توضیحات کاربر مرحله قبل</th>
                                    <th class="text-center ">امکانات</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in listItems">
                                    <td class=" text-center">
                                        {{item.parameterGroupTitle}}
                                    </td>
                                    <td class=" text-center">
                                        {{$filters.toggleDate(item.createDate)}}-{{item.createTime}}
                                    </td>
                                    <td class=" text-center">
                                        {{$filters.shamsiToMonthYear(item.startDate)}} -- {{item.sectionTitles}}
                                    </td>
                                    <td class=" text-center d-none">
                                        {{(item.startDate && item.startDate > 0 ? $filters.toggleDate(item.startDate) : '')}} {{(item.endDate && item.endDate > 0 ? ' تا ' + $filters.toggleDate(item.endDate) : '')}}
                                    </td>
                                    <td class=" text-center">
                                        {{item.firstName}} {{item.lastName}}
                                    </td>
                                    <td class=" text-center">
                                        {{item.beforeLevel_ConfirmStatus == true ? item.currentStatusDesc: 'درخواست رد شده است'}}
                                    </td>
                                    <td class=" text-center">
                                        {{item.beforeLevel_Description}}
                                    </td>
                                    <td class="align-middle text-center">
                                        <button type="button" @click="setStatusRequest(item.confirmDataCartableId, 1)" class="btn btn-success ml-2">
                                            {{item.beforeLevel_ConfirmStatus == true ? 'تایید': 'شروع مجدد روند تایید'}}
                                        </button>
                                        <button type="button" v-if="item.beforeLevel_ConfirmStatus" @click="setStatusRequest(item.confirmDataCartableId, 0)" class="btn btn-danger ml-2">رد</button>
                                        <button type="button" @click="showDetails(item)" class="btn btn-primary">مشاهده</button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import CartabelService from "@/services/Cartabel/Cartabel-service";

    export default {
        name: "CartableManager",
        data() {
            return {
                formPermCode: [
                    { code: 9001, staus: false },
                    { code: 9002, staus: false },
                    { code: 9003, staus: false },
                    { code: 9004, staus: false },
                    { code: 9005, staus: false },
                    { code: 9006, staus: false },
                    { code: 9007, staus: false },
                    { code: 9008, staus: false },
                    { code: 9009, staus: false },
                    { code: 90010, staus: false },
                    { code: 90011, staus: false },
                    { code: 90012, staus: false },
                ],
                listItems: [],
                statusModel: {
                    confirmDataCartableId: 0,
                    confirmStatus: false,
                    description: ''
                },
                removeSelectdItem: true
            };
        },
        components: {
        },
        created() {
            let vm = this;
            this.formPermCode = [
                { code: 9001, staus: vm.$store.getters.currentUser_permByCode(9001) },
                { code: 9002, staus: vm.$store.getters.currentUser_permByCode(9002) },
                { code: 9003, staus: vm.$store.getters.currentUser_permByCode(9003) },
                { code: 9004, staus: vm.$store.getters.currentUser_permByCode(9004) },
                { code: 9005, staus: vm.$store.getters.currentUser_permByCode(9005) },
                { code: 9006, staus: vm.$store.getters.currentUser_permByCode(9006) },
                { code: 9007, staus: vm.$store.getters.currentUser_permByCode(9007) },
                { code: 9008, staus: vm.$store.getters.currentUser_permByCode(9008) },
                { code: 9009, staus: vm.$store.getters.currentUser_permByCode(9009) },
                { code: 90010, staus: vm.$store.getters.currentUser_permByCode(90010) },
                { code: 90011, staus: vm.$store.getters.currentUser_permByCode(90011) },
                { code: 90012, staus: vm.$store.getters.currentUser_permByCode(90012) },
            ];

            var allow = this.formPermCode.filter(function (v) {
                return v.staus.canView
            });

            if (allow.length > 0) {
                this.getRequests();
            }
            else
                this.$router.replace({ path: '/main' });

        },
        methods: {
            getRequests() {
                CartabelService.selectRequestsCartabel().then(response => {
                    let result = response.data;

                    if (!result.isSuccess) {
                        this.$toast.error(result.message);
                    }
                    else {
                        this.listItems = result.data;
                    }
                })
                    .catch(e => {
                        console.log(e);
                    });

            },
            onCallbackDelete(status) {
                if (status)
                    this.getListData();
            },
            getDelUrl(itemId) {
                return CartabelService.getDeleteUrl(itemId);
            },
            setStatusRequest(itemId, status) {
                this.statusModel.confirmDataCartableId = itemId;
                this.statusModel.confirmStatus = status == 1;
                this.showQuestion();
            },
            showQuestion() {

                let title = this.statusModel.confirmStatus ? 'تایید درخواست' : 'رد درخواست';
                let question = `آیا برای ${title} انتخاب شده اطمینان دارید؟`;

                let vm = this;
                this.$swal.fire({
                    title: title,
                    html: `<div>${question}</div>` + (!vm.statusModel.confirmStatus ? `<div class="mt-3">لطفا دلیل رد درخواست را وارد نمایید :</div>` : ''),
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'انصراف',
                    confirmButtonText: 'بله، انجام شود',
                    reverseButtons: true,
                    input: 'textarea',
                    inputClass: "text-danger",
                    inputValue: "",
                    //inputValidator: (value) => {
                    //    debugger
                    //    alert('asdf');
                    //},
                    preConfirm: (value) => {
                        if (!vm.statusModel.confirmStatus && (!value || value.trim() == '')) {
                            this.$swal.showValidationMessage('<i class="fa fa-info-circle"></i> لطفا دلیل رد درخواست را وارد نمایید');
                        }
                        else {
                            vm.statusModel.description = value;
                        }
                    }
                }).then((result) => {
                    if (result.isConfirmed) {
                        CartabelService.setStatusRequest(vm.statusModel)
                            .then(response => {
                                let result = response.data;

                                if (!result.isSuccess) {
                                    vm.$toast.error(result.message);
                                }
                                else {
                                    vm.$toast.success(result.message);
                                    vm.getRequests();
                                }
                            })
                            .catch(e => {
                                console.log(e);
                            });
                    }
                    else {
                    }
                })

            },
            showDetails(itemData) {

                this.removeSelectdItem = false;

                itemData.id = itemData.applyDateId;
                this.$store.state.selectedApplyDate = itemData;
                let url = '';
                switch (itemData.parameterGroupEnum) {
                    case 8:
                        url = 'timex'; //done
                        break;
                    case 9:
                        url = 'hisDoctor';
                        break;
                    case 13:
                        url = 'hisHospital';
                        break;
                    case 14:
                        url = 'doctorQualityScore';
                        break;
                    case 15:
                        url = 'nurseQualityScore';
                        break;
                    case 16:
                        url = 'nonNurseQualityScore';
                        break;
                    case 17:
                        this.$store.state.routeParams.calculateId = itemData.calculateId;
                        if (itemData.calculateTypeEnum == 1) {
                            url = 'detailsDoctorCalculate';
                        }
                        else if (itemData.calculateTypeEnum == 2) {
                            url = 'detailsNurseCalculate';
                        }
                        else if (itemData.calculateTypeEnum == 3) {
                            url = 'detailsEmployeeCalculate';
                        }
                        break;
                    case 18:
                        //ثبت عملکرد گروه پرستاری
                        url = 'nurseQualityInfo';
                        break;
                    case 23:
                        url = 'doctorFullTimePartTime';
                        break;
                    case 24:
                        url = 'doctorDurability';
                        break;
                    case 25:
                        url = 'incentiveFromManagementShare';
                        break;
                    case 26:
                        url = 'incentivePromoteNaturalChildbirth';
                        break;
                    case 27:
                        url = 'hospitalTechnicalRight';
                        break;
                    case 28:
                        url = 'paraclinicManagerTechnicalRight';
                        break;
                    case 29:
                        url = 'assistants';
                        break;
                    case 30:
                        url = 'specialIndependentClinic';
                        break;
                    case 32:
                        url = 'nursePerformance';
                        break;
                    case 35:
                        url = 'durationOfDuty';
                        break;
                    case 36:
                        url = 'workedTime';
                        break;
                    default:
                        break;
                }

                if (url != '') {
                    this.$router.replace({ path: '/' + url });
                }

            }
        },
        unmounted() {
            if (this.removeSelectdItem) {
                this.$store.state.selectedApplyDate = null;
            }
        }
    }
</script>
